const styles = `:host {
  display: table-row-group;
  --goto-datatable-cell-color: var(--goto-text-02);
  --goto-datatable-cell-font: var(--goto-caption-default-02);
  --goto-datatable-row-height: 48px;
}`; export default styles;